import React from 'react';
import PropTypes from 'prop-types';
import { generateBemCss } from 'general/js/helpers';
import { LazyImage } from 'project/lazy-image';
import { hasValue } from '../../../general/js/general-helpers';

const LivePreMessage = ({ model, bemList, patronLogo }) => {
    const bemCss = generateBemCss('live-pre-message', bemList);
    const { textColor } = hasValue(model) ? model : { textColor: undefined };
    const inlineStyle = hasValue(textColor) ? { color: textColor } : {};

    return (
        <div className={bemCss}>
            <div className="live-pre-message__patron">
                <div className="ntt-data-logo">
                    <LazyImage image={patronLogo} />
                </div>
            </div>
            <div className="copy" style={inlineStyle}><b>{model.title}</b></div>
            <div className="copy" style={inlineStyle}>{model.body}</div>
        </div>
    );
};

LivePreMessage.defaultProps = {
    model: {
        title: 'Check back later',
        body: 'We are preparing data'
    }
};

LivePreMessage.propTypes = {
    model: PropTypes.shape({
        title: PropTypes.string,
        body: PropTypes.string,
    }),
    bemList: PropTypes.array,
};

export default LivePreMessage;
